'use client'

import React from 'react'
import Link from 'next/link'
import { CategoryData } from '@/services/dataTypes'
import { ArrowRight } from 'lucide-react'

interface Props {
    categories: CategoryData[]
    cat_slug: string
    slug_type: string
    parentCategory?: string
}

const CategorySidebar = ({ categories, cat_slug, slug_type, parentCategory }: Props) => {
    return (
        <div className="rounded-xl overflow-hidden" style={{ background: '#ffffff', border: '1px solid #f0ede8' }}>
            <div className="px-4 py-3" style={{ borderBottom: '1px solid #f0ede8' }}>
                <p className="text-[13px] font-extrabold " style={{ color: '#8C5826' }}>
                    {parentCategory ? `${parentCategory}` : 'Related Categories'}
                </p>
            </div>

            <div>
                {categories?.slice(0, 10).map((category, i) => (
                    <Link key={i} href={`/${category.url}`}
                        className="flex items-center justify-between px-4 py-2.5 transition-colors hover:bg-amber-50"
                        style={{ borderBottom: '1px solid #f9f6f2' }}>
                        <span className="text-xs font-medium truncate" style={{ color: '#374151' }}>
                            {category?.name}
                        </span>
                        {category?.total_offers > 0 && (
                            <span className="text-[10px] font-bold px-1.5 py-0.5 rounded-md flex-shrink-0 ml-2"
                                style={{ background: '#F8F246', color: '#8C5826' }}>
                                {category.total_offers}
                            </span>
                        )}
                    </Link>
                ))}
            </div>

            <div className="px-4 py-3">
                <Link href={`/${cat_slug}`}
                    className="inline-flex items-center gap-1 text-xs font-semibold transition-all hover:gap-2"
                    style={{ color: '#2CBBC3' }}>
                    See all <ArrowRight size={11} />
                </Link>
            </div>
        </div>
    )
}

export default CategorySidebar
